module.exports = __webpack_public_path__ + "img/livebg.43f8428e.png";